import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { messages } from "../../messages";

interface FilterProps {
    setFilter: (filter: string) => void;
    style: React.CSSProperties;
    className: string;
}

export const Filter = ({ style, className, setFilter }: FilterProps) => {
    const { formatMessage } = useIntl();
    return (
        <div className="table-filter">
            <label htmlFor="table-filter-input"><FormattedMessage {...messages.filter} /></label>
            <input
                type="text"
                name="filter"
                placeholder={formatMessage(messages.filterPlaceholder)}
                onChange={(e) => setFilter((e.target as HTMLInputElement).value)}
                style={style}
                className={className}
                id="table-filter-input"
            />
        </div>
    );
};
